import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { LocalVesselSearch } from './model';
import { TypeaheadInput } from 'portcall/typeahead/view';

export const LocalVesselSearchView = SuperCritical(({ model, tabIndex, placeholder, specificInput } : {
    model : LocalVesselSearch,
    tabIndex? : number,
    placeholder? : string,
    specificInput? : string
}) =>
    <div className="vessel-search">
        <TypeaheadInput
            className="search-filter" 
            placeholder={placeholder ?? "Search a vessel by name, IMO, Call Sign, or MMSID"}
            model={model.Typeahead}
            tabIndex={tabIndex}
            specificInput={specificInput}
        />
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/localvesselsearch/view.tsx